import { render, staticRenderFns } from "./TherapistDashModalDeleteBooking.vue?vue&type=template&id=c21c61dc&scoped=true"
import script from "./TherapistDashModalDeleteBooking.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalDeleteBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c61dc",
  null
  
)

export default component.exports